import { render, staticRenderFns } from "./ScarceType.vue?vue&type=template&id=75d11c14&scoped=true&"
import script from "./ScarceType.vue?vue&type=script&lang=js&"
export * from "./ScarceType.vue?vue&type=script&lang=js&"
import style0 from "./ScarceType.vue?vue&type=style&index=0&id=75d11c14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d11c14",
  null
  
)

export default component.exports